import type { Component } from "vue";
import {
  CalendarDays,
  CalendarRange,
  Scissors,
  Store,
  UserCog,
  Users,
} from "@lucide/vue";

/**
 * Конфіг навігації app-shell — частотний поділ IA D2:
 * «Щоденна робота» (Записи · Графік · Клієнти) і
 * «Налаштування салону» (Майстри · Послуги · Профіль салону).
 *
 * Це widget-локальна композиція (не DS-примітив): структура прив'язана до
 * роутів адмінки + конкретної ментальної моделі власниці, не перевикористовна
 * атомарна абстракція. Іконки — lucide.
 */
export type NavZoneId = "daily" | "settings";

export interface NavItemDef {
  /** Ім'я vue-router роуту (для тестів/перевірок). */
  name: string;
  /** Цільовий шлях. */
  to: string;
  /** i18n-ключ підпису. */
  labelKey: string;
  /** lucide-іконка. */
  icon: Component;
  /** Активність за точним збігом шляху (потрібно для головного `/`). */
  exact?: boolean;
}

export interface NavZoneDef {
  id: NavZoneId;
  /** i18n-ключ заголовка зони. */
  titleKey: string;
  items: NavItemDef[];
}

export const navZones: NavZoneDef[] = [
  {
    id: "daily",
    titleKey: "nav.zones.daily",
    items: [
      { name: "home", to: "/", labelKey: "nav.journal", icon: CalendarDays, exact: true },
      { name: "schedule", to: "/schedule", labelKey: "nav.schedule", icon: CalendarRange },
      { name: "clients", to: "/clients", labelKey: "nav.clients", icon: Users },
    ],
  },
  {
    id: "settings",
    titleKey: "nav.zones.settings",
    items: [
      { name: "masters", to: "/masters", labelKey: "nav.masters", icon: UserCog },
      { name: "services", to: "/services", labelKey: "nav.services", icon: Scissors },
      { name: "salon-profile", to: "/salon-profile", labelKey: "nav.salonProfile", icon: Store },
    ],
  },
];

/**
 * Seam role-gating (IA D3, RBAC — feature-021). Зараз owner-режим: усі зони
 * видимі. Майстру зона «Налаштування салону» приховується — для цього
 * feature-021 передасть сюди `canManageSalon = session.role === "owner"`.
 * Більше НІДЕ міняти не треба: sidebar бере зони ЛИШЕ через цей фільтр.
 */
export function visibleNavZones(canManageSalon: boolean): NavZoneDef[] {
  return navZones.filter((zone) => zone.id !== "settings" || canManageSalon);
}
